import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { catchError, map, Observable, of, Subscription, switchMap, takeUntil, tap } from 'rxjs';
import { ConfigService } from 'src/app/core/services/config.service';
import { select, Store } from '@ngrx/store';
import { AppStateInterface } from 'src/app/appState.interface';
import { getCompleteState } from 'src/app/core/store/selectors';
import { SelectedCustomerCacheInterface } from 'src/app/core/store/interface/selectedCustomerCache.interface';
import { PORTAL_CONFIG, VEHICLE_MODELS } from 'src/app/core/config/config.constants';
import { ApiService } from 'src/app/core/services/api.service';
import { setConfGlobal } from 'src/app/core/store/globalConfig/conf-global.actions';

@Component({
  selector: 'app-config-page',
  templateUrl: './config-page.component.html',
  styleUrls: ['./config-page.component.scss']
})
export class ConfigPageComponent implements OnInit, OnChanges {
  @Input() uidCustomer: string = '';
  page: string = 'map';
  @Output() closeNav = new EventEmitter<boolean>();
  getCompleState: Subscription;
  selectedCustomerUidSelector$: SelectedCustomerCacheInterface;
  signal: any;
  vehicleModels$: any = []
  destroy$: any;
  fields: FormlyFieldConfig[] = []
  subscriptions: any;
  constructor(private configService: ConfigService, private store: Store<AppStateInterface>, private apiService: ApiService) {

  }
  form = new FormGroup({
  });

  model = {
  };

  multiSelectOptions = [
    { value: 'weather', label: 'Meteo' },
    { value: 'geofence', label: 'Geofence' },
    { value: 'fields', label: 'Unità produttive' },
    { value: 'showFields', label: 'Mostra unità produttive' },
  ];

  switchOptions = [
    { label: 'Attiva', value: true },
    { label: 'Disattiva', value: false },
  ];



  ngOnInit() {
    this.getCompleState = this.store.pipe(select(getCompleteState)).subscribe((res) => {
      this.selectedCustomerUidSelector$ = res.applyCustomer
      this.pageConfig('get', 'map', this.selectedCustomerUidSelector$.uid);
      this.vehicleModels$ = [];
      this.modelVehicle();
    });

    this.configService.onRefresh().subscribe(() => {
      this.pageConfig('get', 'map', this.selectedCustomerUidSelector$.uid);
      this.modelVehicle();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.channels) {
    //  console.log('Signal:', this.signal);
    }
  }

  ngDestyroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscriptions.unsubscribe();
  }

  onSubmit() {
    if (this.form.valid) {
      //console.log('Valori del form (SelectButton):', this.model);
      this.pageConfig('post', 'map', this.selectedCustomerUidSelector$.uid, this.model);

    }
  }

  closeNavConf() {
    this.closeNav.emit(false);
  }

  modelVehicle(): void {
    this.form.reset();
    let params = {
      uidCustomer: this.selectedCustomerUidSelector$.uid
    };

    const modelsSubscription = this.apiService.getWithParams(VEHICLE_MODELS, params).pipe(
      switchMap((vehicleModels: any) => {
        const options = vehicleModels.map((item: any) => ({
          label: item.modelName,
          value: item.uid
        }));
        this.vehicleModels$ = options;

        const url = PORTAL_CONFIG + this.selectedCustomerUidSelector$.uid + '/portalConfig?findAncestor=true';

        return this.apiService.get(url);
      })
    ).subscribe({
      next: (res) => {
        const response = res as { data: string };
        this.signal = JSON.parse(response.data);
        console.log('Signal:', this.signal);
        this.store.dispatch(setConfGlobal({ confGlobal: this.signal }));
        this.signal.configurations.forEach(config => {
          const vehicleModel = this.vehicleModels$.find(
            model => model.value === config.selectModel
          );

          if (vehicleModel) {
            config.modelLabel = vehicleModel.label;

          } else {
            console.warn(`Nessun modello di veicolo trovato in this.vehicleModels$ per selectModel: ${config.selectModel}`);
          }
        });

      //  console.log('Signal dopo la modifica (con modelLabel):', this.signal);
        this.fields = [
          {
            key: 'selectedSignalsByModel',
            type: 'signal-cards',
            props: {
              label: 'Segnali Disponibili',
              signalData: this.signal.configurations
            },
          }
        ];
      },
      error: (err) => {
        console.error('Errore durante il recupero dati:', err);
      }
    });
    if (this.subscriptions)
      this.subscriptions.add(modelsSubscription);
  }

  pageConfig(method: 'get' | 'post' | 'delete', pagePath: string, uid?: any, conf?: any,) {
    const url = PORTAL_CONFIG + uid + '/pageConfig/' + pagePath + '?findAncestor=true';
    let request$;

    switch (method) {
      case 'get':
        request$ = this.apiService.get(url);
        break;
      case 'post':
        request$ = this.apiService.post(url, conf);
        break;
      case 'delete':
        request$ = this.apiService.delete(url);
        break;
      default:
        console.error(`Metodo HTTP non supportato: ${method}`);
        return;
    }

    request$.subscribe({
      next: (res) => {
        if (method === 'get') {
         // console.log('Configurazione del portale:', JSON.parse(res.data));
          if (res.data !== null) {
            this.model = JSON.parse(res.data);
            localStorage.setItem('resposeMap', JSON.stringify(this.model));

          }
          return { configurations: JSON.parse(res.data) };
        }
        if (method === 'post') {
          this.closeNav.emit(false);
          this.pageConfig('get', 'map', this.selectedCustomerUidSelector$.uid);
        }
        return res;
      },
      error: (err) => {
      }
    });
  }

}
